// Popup "Přidáno do košíku" - úprava obsahu podle návrhu (styly: scss/components/_advancedOrder.scss).

// Colorbox se otevře malý, po načtení obsahu se roztáhne a po našich úpravách znovu změní velikost.
// Proto box po dobu přípravy schováme (body.advancedOrderLoading), animaci vypneme (speed 0)
// a ukážeme ho až ve finální velikosti.
const aoColorboxDefaultSpeed = $.colorbox ? $.colorbox.settings.speed : 300;
let aoRevealTimer;

function advancedOrderReveal() {
  clearTimeout(aoRevealTimer);
  $("body").removeClass("advancedOrderLoading");
}

function advancedOrderReset() {
  advancedOrderReveal();
  if ($.colorbox) $.colorbox.settings.speed = aoColorboxDefaultSpeed;
}

function advancedOrderStart() {
  if (!$.colorbox) return;
  $("body").addClass("advancedOrderLoading");
  $.colorbox.settings.speed = 0;
  clearTimeout(aoRevealTimer);
  aoRevealTimer = setTimeout(advancedOrderReset, 5000); // pojistka, kdyby se box nikdy neotevřel
}

// Shoptet načítá obsah přes nativní XHR (jQuery ajaxSend se nespustí), proto hook na XMLHttpRequest.open
const aoXhrOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url) {
  if (typeof url === "string" && url.indexOf("/action/Cart/GetExtendedOrder/") !== -1) {
    advancedOrderStart();
    this.addEventListener("loadend", function () {
      if (this.status !== 200) advancedOrderReset();
    });
  }
  return aoXhrOpen.apply(this, arguments);
};

document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
  const $ao = $(".advanced-order");
  if (!$ao.length || $ao.data("aoReady")) return;
  $ao.data("aoReady", true);

  $("#colorbox").addClass("advancedContent");

  $ao.find(".ao-price .unit-value").text("za kus");

  const $buttons = $ao.find(".advancedOrder__buttons");
  $buttons.find("button.colorbox-close").text("Pokračovat v nákupu");
  $buttons.find("a.btn-conversion").text("Přejít do košíku");

  const $discount = $ao.find(".extra.discount");
  if ($discount.length) {
    $discount.html(popupKosikPoRegistraci);
    /*  '<span class="extra-title">Nakupujete na IČO? Získejte 5% slevu. ' +
        '<a href="/registrace/">Registrovat se</a></span>' +
        '<span class="extra-note">Sleva se nevztahuje na akční produkty a speciální ceny.</span>',
    );*/
    $buttons.append($discount);
  }

  $ao
    .find(".advanced-order-suggestion")
    .html('Mohlo by se vám hodit <span class="ao-suggestion-note">Inspirace pro váš salon</span>');

  // doporučené produkty: max 3 vedle sebe, zbytek slick (šipky u nadpisu)
  const $products = $ao.find(".products-additional");
  if ($products.length && $.fn.slick && !$products.hasClass("slick-initialized")) {
    const $heading = $ao.find(".advanced-order-suggestion");
    $products.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      appendArrows: $heading.length ? $heading : $products,
      infinite: false,
      adaptiveHeight: false,
      // do 359 px 1 produkt, od 360 px 2, od 768 px 3 (breakpointy se nededí, každý má vlastní kompletní settings)
      responsive: [
        { breakpoint: 767, settings: { slidesToShow: 2, dots: true, appendArrows: $products } },
        { breakpoint: 359, settings: { slidesToShow: 1, dots: true, appendArrows: $products } },
      ],
    });
  }

  // běží až po všech listenerech této události; box se ukáže až po přepočtu velikosti (a načtení obrázku produktu)
  setTimeout(function () {
    let revealed = false;
    const reveal = function () {
      if (revealed) return;
      revealed = true;
      if ($.colorbox) $.colorbox.resize();
      // slick se inicializoval před finální šířkou boxu - přepočítat až po resize
      const repositionSlider = function () {
        if ($products.hasClass("slick-initialized")) $products.slick("setPosition");
      };
      repositionSlider();
      requestAnimationFrame(function () {
        repositionSlider();
        advancedOrderReveal();
      });
      setTimeout(repositionSlider, 300); // colorbox dokončí přesun/animaci
    };
    const img = $ao.find(".ao-image img")[0];

    if (img && !img.complete) {
      $(img).one("load error", reveal);
      setTimeout(reveal, 600); // obrázek nesmí box držet schovaný donekonečna
    } else {
      reveal();
    }
  }, 0);
});

$(document).on("cbox_closed", function () {
  $("#colorbox").removeClass("advancedContent");
  advancedOrderReset();
});
